export default "__VITE_ASSET__C12ZiGkW__"